import "./FirstScreen.scss";
import { NewsInternational_Plain } from "../../../types/api/news-international.ts";
import { getStrapiMedia } from "../../../utils/utils.tsx";

const FirstScreen = ({ data }: { data: NewsInternational_Plain }) => {
  return (
    <section className="news-first-screen">
      <div className="wrapper">
        <div className="news-first-screen__text">
          <h1>{data.data.title}</h1>
        </div>
        <img
          src={getStrapiMedia(data.data.titleImage?.url)}
          srcSet={`            
            ${getStrapiMedia(data.data.titleImageMob?.url)} 767w,
            ${getStrapiMedia(data.data.titleImage?.url)}
          `}
          alt={data.data.title}
        />
      </div>
    </section>
  );
};

export default FirstScreen;
